import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";
import {Link} from "react-router-dom";


const PortfolioList = [
    {
        image: 'image-1',
        category: 'Web Development',
        businsessSegment: 'Healthcare',
        title: ' Middleware in Healthcare',
        link: '/case/middleware-in-healthcare'
    },
    {
        image: 'image-2',
        category: 'Web Development & Data Analytics',
        businsessSegment: 'Internet Of Things',
        title: ' IoT Platform For Water',
        link: '/case/iot-platform-for-water'
    },
    {
        image: 'image-3',
        category: 'Blockchain Development',
        businsessSegment: 'Cryptocurrencies',
        title: 'Decentralized Exchange',
        link: '/case/decentralized-exchange'
    },
    {
        image: 'image-4',
        category: 'Blockchain Development',
        businsessSegment: 'Non-fungible token',
        title: ' NFT Marketplace',
        link: '/case/nft-marketplace'
    },
    {
        image: 'image-8',
        category: 'Web Development',
        businsessSegment: 'Web Development',
        title: 'Generatore Offerte B2B',
        link: '/case/b2b-offer-generator'
    },
    {
        image: 'image-5',
        category: 'Artificial Intelligence',
        businsessSegment: 'Non-fungible token',
        title: 'AI for documents search',
        link: '/case/ai-documents'
    }
];

class Portfolio extends Component{
    render(){
        const { list = [] } = this.props;
        const items = (list.length <= 0 ? PortfolioList : list);
        let title = 'Case Studies',
        description = 'Amiamo le sfide, ecco come le affrontiamo';
        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio-slick-activation mt--70 mt_sm--40">
                        <Slider {...portfolioSlick2}>
                            {items.map((value , index) => (
                                <div className="portfolio" key={index}>
                                    <div className="thumbnail-inner">
                                        <div className={`thumbnail ${value.image}`}></div>
                                        <div className={`bg-blr-image ${value.image}`}></div>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>{value.category}</p>
                                            <h4 className="title">
                                                <a href={`${value.link ? value.link : '/portfolio-details'}`}>{value.title}</a>
                                            </h4>
                                        </div>
                                    </div>
                                    <Link className="link-overlay" to={`${value.link ? value.link : '/portfolio-details'}`}></Link>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;